import React from 'react'
import './index.less';

export const Footer = () => {

  const origin = process.env.REACT_APP_DSERS_ORIGIN;

  return <div>
    <footer className="main-footer">
      <div className='footerContainer'>
        <div className='logo'>
          <img width={138} src="https://img.dsers.com/dsevs_dev/footer_dsers_logo.png" />
          <div className='logo-icon'>
            <a target="_blank" href="https://www.facebook.com/DSersOfficial"><img src="https://img.dsers.com/dsevs_dev/facebook.svg" /></a>
            <a target="_blank" href="https://www.youtube.com/dsers" className='moive'><img src="https://img.dsers.com/dsevs_dev/youtube.svg" /></a>
            <a target="_blank" href="https://twitter.com/dsersofficial"><img src="https://img.dsers.com/dsevs_dev/logo_twitter.svg" /></a>
            <a target="_blank" href="https://www.instagram.com/dsers_official"><img src="https://img.dsers.com/dsevs_dev/instagram.svg" /></a>
          </div>
        </div>
        <div className='description'>
          <div className='list'>
            <p>Company</p>
            <a href={`${origin}/about/`} target="_blank">About us</a>
            <a href={`${origin}/contact/`} target="_blank">Contact Us</a>
            <a href={`${origin}/partner/`} target="_blank">Partners</a>
            <a href={`${origin}/privacy/`} target="_blank">Privacy Policy</a>
            <a href={`${origin}/terms-of-service/`} target="_blank">Terms of Service</a>
          </div>
          <div className='list active'>
            <p>Why Choose DSers</p>
            <a href={`${origin}/place-orders-in-batches/`}>Place Orders in Batches</a>
            <a href={`${origin}/find-best-suppliers/`}>Find the Best Suppliers</a>
            <a href={`${origin}/manage-stores-in-one-place/`}>Manage Stores in One Place</a>
            <a href={`${origin}/create-sales-offers/`}>Create Sales Offers</a>
            <a href={`https://www.messenger.com/t/DSersOfficial`} target="_blank" rel="noopener noreferrer">24/7 Live Customer Service</a>
          </div>
          <div className='list active'>
            <p >Blog</p>
            <a href="https://www.dsers.com/blog/" target="_blank" rel="noopener noreferrer">Latest Articles</a>
            <a href="https://www.dsers.com/blog/dropshipping/" target="_blank" rel="noopener noreferrer">Dropshipping</a>
            <a href="https://www.dsers.com/blog/ecommerce-guide/" target="_blank" rel="noopener noreferrer">Ecommerce Guide</a>
            <a href="https://www.dsers.com/blog/marketing-tips/" target="_blank" rel="noopener noreferrer">Marketing Tips</a>
            <a href="https://www.dsers.com/blog/niche-market/" target="_blank" rel="noopener noreferrer">Niche Market</a>
          </div>
          <div className='list active'>
            <p >Help Center</p>
            <a href='https://help.dsers.com' target="_blank"><img src="https://img.dsers.com/dsevs_dev/email.svg" />Need a Help</a>

            <a href='mailto:supply-support@dserspro.com' target="_blank"><img src="https://img.dsers.com/dsevs_dev/email.svg" />Contact Support</a>
            <a href='https://www.messenger.com/t/DSersOfficial' target="_blank"><img src="https://img.dsers.com/dsevs_dev/jiqi.svg" />Live Chat Now</a>
          </div>
        </div>
      </div>
      <p className='content'>© 2018-2022 DSers All rights reserved. ICP: BJ-18032848</p>
    </footer >
  </div>
}